/**
 * Component này dùng để style các form in pdf, đảm bảo nhất quán về font chữ theo yêu cầu là Times New Roman
 */
const FontFamilyToPrint = () => {
  return (
    <style>
      {`
        @media print {
          .MuiTableContainer-root, .MuiTableContainer-root * {
            font-family: "Times New Roman", Times, serif !important;
          }
        }
      `}
    </style>
  );
};

export default FontFamilyToPrint;
